import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createUserPreferenceActions } from './actions';
import { UserPreferenceActions, UserPreferenceState } from './types';

export const useUserPreferenceStore = create<UserPreferenceState & UserPreferenceActions>()(
    immer((set, get, store) => ({
        selectedUserPreference: null,
        loadingUserPreference: false,
        error: undefined,
        ...createUserPreferenceActions(set, get, store),
    })),
);
